import { render } from "./PrerequisityList.vue?vue&type=template&id=7673cf5e"
import script from "./PrerequisityList.vue?vue&type=script&lang=js"
export * from "./PrerequisityList.vue?vue&type=script&lang=js"

import "./PrerequisityList.vue?vue&type=style&index=0&id=7673cf5e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__